<template lang="pug">
.preview-iphone
  v-card.round-xl(elevation="2" width="320px")
    .px-4.py-2
      .d-flex.justify-space-between.align-center.mb-2
        .text-xs.font-semibold {{ time }}
        div
          v-icon.mr-1(size="15" color="basic700") mdi-signal
          v-icon.mr-1(size="15" color="basic700") mdi-wifi
          v-icon(size="20" color="basic700") $yzi-ios-battery-full
      slot
    preview-iphone-home-bar.py-2(v-if="homeBar")
</template>

<script>
import PreviewIphoneHomeBar from '@/components/review/preview/PreviewIphoneHomeBar.vue'

export default {
  name: 'PreviewIphone',
  components: {
    PreviewIphoneHomeBar
  },
  props: {
    time: {
      type: String,
      default: '9:41'
    },
    homeBar: {
      type: Boolean
    },
    safariBottomSearch: {
      type: String,
      default: null
    }
  },
}
</script>

<style scoped>
</style>